module.exports = __webpack_public_path__ + "static/media/custommat-v2-mobile-stock-photo.cf6b4394.png";